export default "__VITE_ASSET__uym2iNFF__";